import { Injectable, inject } from '@angular/core';
import { ConfigService } from '@app/shared/services/config/config.service';
import { PasswordBaseService } from './password-base.service';

@Injectable({
  providedIn: 'root'
})
export class PasswordChangeService extends PasswordBaseService {

  public configService = inject(ConfigService);
  public apiUrl = '/Account/PasswordChange';

  changePassword(openInNewTab: boolean) {
    super.replaceWindowUrl(openInNewTab);
  }
}
